import type { ComponentPublicInstance } from "vue";
import { ref } from "vue";
import { useKeyboardAvoidance } from "~/composables/useKeyboardAvoidance";
import useIsMobile from "~/composables/useIsMobile";


export class R3VisualComponentBase {
	private _visible: Ref<boolean> = ref(true);

	public get visible(): boolean {
		return this._visible.value;
		// return isRef(this._visible) ? this._visible.value : this._visible;
	}

	public set visible(value: boolean) {
		this._visible.value = value;
		// if (isRef(this._visible)) {
		// 	this._visible.value = value;
		// } else {
		// 	this._visible = value;
		// }
	}
	private _enabled = ref(true)

	public get enabled(): boolean {
		return this._enabled.value;
	}
	public set enabled(value: boolean) { this._enabled.value = value; }

	public name: string = '';

	style: object = {};

	elemento = ref<ComponentPublicInstance | null>(null);

	/**
	 * Foca no input do ref correspondente.
	 */
	async setFocus(): Promise<void> {

		if (this.elemento.value == null) {
			console.warn("Element not defined");
			return;

		} else {
			// @ts-expect-error - focus pode não estar disponível em todos os elementos
			this.elemento.value.focus();

		}

	}

	/**
	 * Called when the component is shown/activated.
	 * Subclasses that override onShow MUST call super.onShow() to preserve keyboard avoidance.
	 */
	protected onShow(): void {
		if (!import.meta.client) return;
		const { isMobileDevice } = useIsMobile();
		if (!isMobileDevice.value) return;

		const rootEl = this.$el as HTMLElement | undefined;
		if (!rootEl) return;

		useKeyboardAvoidance().attach(rootEl);
	}

	/**
	 * Called when the component is unmounted/closed.
	 * Subclasses that override onUnmount MUST call super.onUnmount() to preserve keyboard avoidance cleanup.
	 */
	protected onUnmount(): void {
		if (!import.meta.client) return;
		useKeyboardAvoidance().detach();
	}

	/**
	 * Called when the virtual keyboard opens. Override to customize behavior.
	 * @param keyboardHeight The height of the keyboard in pixels
	 */
	protected onKeyboardOpen(keyboardHeight: number): void {
		// No-op default — subclasses override for custom behavior
	}

	/**
	 * Called when the virtual keyboard closes. Override to customize behavior.
	 */
	protected onKeyboardClose(): void {
		// No-op default — subclasses override for custom behavior
	}
}
